import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { FlexControlledForm, useDebounceState } from '@common-fe/common-fe';

import { AccountAccessPayload, useStore } from '@/modules/user/components/SignUp/AccountAccess/useAccountAccess.store';

import useSecurityFields from './hooks/useSecurityFields';

const SecurityForm = () => {
  const { t } = useTranslation();
  const showErrors = useStore((state) => state.showErrors);
  const fields = useSecurityFields();

  const handleSetState = useStore((state) => state.setState);
  const { setValues, values } = useDebounceState<Partial<AccountAccessPayload>>();

  useEffect(() => {
    if (values) {
      handleSetState(values);
    }
  }, [handleSetState, values]);

  return (
    <FlexControlledForm
      formTitle={t('Security')}
      fields={fields}
      showError={showErrors}
      editMode
      onChangeValues={setValues}
    />
  );
};

export default SecurityForm;
